var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPotatoes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C8078;}\n\t.st1{fill:#997041;}\n\t.st2{fill:#AE7E4A;}\n\t.st3{fill:#C79C68;}\n\t.st4{fill:#D5B07F;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.53,80.86c0,0,59.89-18.72,62.75,25.92l-39.72,2.54l-14.66-12.08L92.53,80.86z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.31,105.83c0.42-17.72,11.9-23.57,18.75-27.07c0.45-0.23,0.88-0.45,1.28-0.66c2.75-1.44,5.59-1.87,7.82-1.93 c-0.19,0.63-0.05,1.33,0.44,1.83c0.36,0.37,0.84,0.55,1.31,0.55c0.47,0,0.94-0.18,1.3-0.53c3.28-3.24,8.36-3.68,12.88-3.23 c-0.38,0.21-0.76,0.45-1.13,0.71c-3.66,2.63-5.85,7.18-6.51,13.54c-2.27,21.86-0.32,36.47,5.8,43.42c0.42,0.48,0.87,0.91,1.33,1.31 c-16.34-0.46-24.71-6.93-24.84-7.03c-0.79-0.64-1.95-0.52-2.59,0.28c-0.25,0.31-0.38,0.67-0.4,1.04c-2.54-0.91-5.29-2.36-7.81-4.53 C55.34,120.44,51.1,114.85,51.31,105.83z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.52,74.92c0,0-46.74-6.53-47.91,25.82c-1.17,32.35,18.09,31.57,48.02,33.91L99.52,74.92z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M102.58,134.39c-0.67,0.09-1.33,0.17-1.98,0.24c-0.32,0.01-0.64,0.03-0.96,0.02c-3.13-0.07-5.64-1.24-7.68-3.56 c-5.65-6.41-7.44-21.27-5.19-42.97c0.58-5.54,2.34-9.42,5.24-11.53c3.44-2.5,7.48-1.68,7.51-1.67c0.13,0.03,0.25,0.04,0.38,0.05 c4.07,0.1,9.73,4.71,13.59,26.02c-4.08,2-6.45,4.32-7.25,5.2c-3.39,1.69-4.34,3.73-4.52,5.16c0,0.03,0,0.05,0,0.08 c-0.01,0.07-0.03,0.14-0.03,0.22c0,0.03,0,0.13,0,0.27c0,0.05,0,0.1,0,0.16c0.02,1.83,0.34,9.35,4.32,17.06 c0.47,0.9,1,1.83,1.6,2.76C106.14,133.18,104.47,134.01,102.58,134.39z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M131.77,139.9c-26.95-0.64-33.64-18.57-35.29-28.19c5.88,2.27,19.22,4.3,31.35,4.59 c1.05,0.03,2.08,0.04,3.09,0.04c15.14,0,25.26-2.84,31.62-8.82c0.14,1.45,0.21,3.09,0.16,4.87 C161.93,137.86,140.81,140.1,131.77,139.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M162.26,106.03c0.01,0.02,0.02,0.04,0.04,0.07c0.1,0.15,0.21,0.38,0.33,0.69c0.12,0.71-0.55,1.61-1.16,2.25 c-5.91,6.19-16.29,8.87-32.64,8.49c-17.13-0.42-30.07-3.82-31.58-5.12c-0.31-0.27-0.83-0.8-0.76-1.34c0.08-0.61,0.88-1.61,2.92-2.59 c0.29-0.14,0.55-0.35,0.75-0.6c0.05-0.06,4.93-6.02,15.34-7.85c3.84-0.67,8.51-0.94,13.21-0.94c8.59,0,17.26,0.88,21.09,1.77 C158.57,102.91,161.38,104.88,162.26,106.03z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPotatoes);
export default __webpack_public_path__ + "static/media/Potatoes.cd4e2cf45fe169f05bbe78187d67d912.svg";
export { ForwardRef as ReactComponent };